import React, { useState, useEffect } from "react";
import PropTypes from "prop-types"; //  Import PropTypes
import { useTranslation } from "react-i18next";
const VendorListMobile = ({handlePageChange, currentPage, nextPage, prevPage, count, data, screenWidth}) => {

  const { t } = useTranslation();

  return (
    <>
      {data.length > 0 ? (
        data.map((item, index) => (
          <div key={index} className="rounded text-secondary mb-3 text-dark">
            <div className="w-100 p-3 rounded-top" style={{ backgroundColor: "#DAF8FD" }}>
              <h5 className="text-dark fw-bolder mb-2">{item.name}</h5>
            </div>
            <div className="bg-white p-3 rounded-bottom">
              <div className="row">
                <div className="col-3" style={{paddingRight: 5}}>
                  <p style={{fontSize: "0.7rem"}}>{t("Email")}</p>
                </div>
                <div className="col-1 text-center">
                  <p style={{ fontSize: "0.7rem" }}>:</p>
                </div>
                <div className="col-7">
                  <p style={{fontSize: "0.7rem"}} className="fw-bold">{item.email}</p>
                </div>
              </div>
              <div className="row">
                <div className="col-3" style={{paddingRight: 5}}>
                  <p style={{fontSize: "0.7rem"}}>{t("Contact")}</p>
                </div>
                <div className="col-1 text-center">
                  <p style={{ fontSize: "0.7rem" }}>:</p>
                </div>
                <div className="col-7">
                  <p style={{fontSize: "0.7rem"}} className="fw-bold">{item.phone}</p>
                </div>
              </div>
              <div className="row">
                <div className="col-3" style={{paddingRight: 5}}>
                  <p style={{fontSize: "0.7rem"}}>{t("Location")}</p>
                </div>
                <div className="col-1 text-center">
                  <p style={{ fontSize: "0.7rem" }}>:</p>
                </div>
                <div className="col-7">
                  <p style={{fontSize: "0.7rem"}} className="fw-bold">{item.location}</p>
                </div>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="p-3 rounded bg-white text-secondary mb-3">
          <p>No Data</p>
        </div>
      )}

            {/* Pagination Controls */}
      <div className="mt-3">
        <button
          className="btn btn-secondary me-2"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          {t("Previous")}
        </button>
        <span>{t("Page")} {currentPage} {t("of")} {Math.ceil(count / 10)}</span>
        <button
          className="btn btn-secondary ms-2"
          onClick={() => handlePageChange(currentPage + 1)}
        >
          {t("Next")}
        </button>
      </div>
    </>
  )
}

VendorListMobile.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  screenWidth: PropTypes.number.isRequired,

  handlePageChange: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
  nextPage: PropTypes.func.isRequired,
  prevPage: PropTypes.func.isRequired,
  count: PropTypes.number.isRequired,
};

export default VendorListMobile